

























































import { Vendor } from '@/models/vendor';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import Proxyable from '@/mixins/proxyable';

export default Proxyable.extend({
  name: 'VendorSearch',

  data: () => ({
    isLoading: false,
    model: null as any,
    search: '' as string
  }),

  computed: {
    vendors: get<Vendor[]>('vendor/vendors'),
    getVendorById: get<(id: string) => Vendor>('vendor/getVendorById'),

    internalValue: {
      get(): unknown {
        return this.internalLazyValue;
      },
      set(value: any) {
        if (value === this.internalLazyValue) return;

        this.internalLazyValue = value;
        this.setValue(value);
      }
    }
  },

  mounted() {
    if (this.internalValue) {
      this.tryGetOrFetchVendor(this.internalValue);
    }
  },

  methods: {
    ...mapActions({
      fetchVendors: 'vendor/fetchVendors'
    }),

    setData() {
      this.isLoading = true;
      return this.fetchVendors().finally(() => {
        this.isLoading = false;
      });
    },

    clear() {
      this.$emit('clearVendor');
    },

    async setValue(val: Vendor) {
      this.$emit('update:text', val ? String(val.id + ' - ' + val.name) : '');
      this.$emit('select', val);
      this.$emit('input', val ? val.id : null);
      this.$emit('change', val ? val.id : null);
    },

    async tryGetOrFetchVendor(identifier: string) {
      const vendor = this.getVendorById(identifier);
      if (vendor) {
        this.internalLazyValue = vendor.id;
      } else {
        this.setData().then(() => {
          // make another call back to updated store getter to get current vendor to display
          this.internalLazyValue = this.getVendorById(identifier);
        });
      }
    }
  }
});
